module.exports = __webpack_public_path__ + "img/薄荷.44c34f39.jpg";